import { AxiosResponse } from "axios";

import { SurveyBlocks } from "modules/MainSurveyEditor/surveyBlocks";
import { camelizeObject, snakizeObject } from "shared/helpers/object";
import { ApiBaseUrl, request } from "shared/clients/baseClient";
import { Conditions } from "../conditions";

const createCondition = (
  parentSurveyId: number | string,
  blockId: number | string,
  params: Partial<Conditions.Condition>
): Promise<AxiosResponse<Conditions.Condition>> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${parentSurveyId}/survey_block/${blockId}/condition/`,
      method: "POST",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<Conditions.ConditionApi>) => {
    return camelizeObject(data);
  });
};

const updateCondition = (
  parentSurveyId: number | string,
  blockId: number | string,
  id: number | string,
  params: Partial<Conditions.Condition>
): Promise<number> => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${parentSurveyId}/survey_block/${blockId}/condition/${id}/`,
      method: "PATCH",
      data: snakizeObject(params),
    },
  }).then((data: AxiosResponse<SurveyBlocks.BlockApi>) => {
    return data.data.id;
  });
};

const deleteCondition = (parentSurveyId: number | string, blockId: number | string, id: number | string) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${parentSurveyId}/survey_block/${blockId}/condition/${id}/`,
      method: "DELETE",
    },
  });
};

export const conditionClient = {
  createCondition,
  updateCondition,
  deleteCondition,
};
